import React, { useState } from 'react';
import Config from "@skin_config";
import PropTypes from 'prop-types';

import './style.scss';
import { useTranslation } from '@common/hooks/translation';
import KeyboardFormField from '@common/components/keyboardFormField';
import { fields } from './constants/fields';
import { confirmation } from './helpers/confirmation';

const PayoutRequest = ({ defer, closePopup, winId, betId, isCasino, currencyId }) => {
  const t = useTranslation();

  const [form, setForm] = useState({
    Name: '',
    MiddleName: '',
    LastName: '',
    Email: '',
    PersonalIdentificationDocNumber: '',
    IBAN: '',
    BankName: '',
    BicCode: '',
    PhoneNumber: {
      code: '+359',
      phone: '',
    },
  });

  const [errors, setErrors] = useState({});

  const onChange = (item, value) => {
    let errorMessage = '';
    setForm({ ...form, [item.name]: value });

    if (!value && !item.isOptional) errorMessage = 'Field is required';
    else errorMessage = item.isOptional && !value ? '' : !item.isFieldValid(value) && item.errorMessage;

    setErrors((prevErrors) => ({
      ...prevErrors,
      [item.name]: errorMessage,
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    fields.forEach((field) => {
      const {
        name, isFieldValid, errorMessage, isOptional,
      } = field;
      const value = form[name];

      if (!(isOptional && !value)) {
        if (!!isFieldValid && !isFieldValid(value)) {
          isValid = false;
          newErrors[name] = errorMessage;
        }
      }
    });

    setErrors(newErrors);

    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const isSuccess = confirmation(form, isCasino ? winId : betId, isCasino, currencyId);
      defer.resolve(isSuccess);
    }
  };

  return (
    <form className="popup-content popup-small popup-wide-form-content" onSubmit={handleSubmit}>
      <h3 className="popup-title">{t('Request a payout')}</h3>
      <div className="popup-main-content popup-wide-form">
        <div className="input-wrapper">
          {fields.map((item) => {
            const FieldComponent = item.customViewComponent || KeyboardFormField;
            return (
              <div className="single-input">
                <FieldComponent
                  key={item.name}
                  name={item.fieldName}
                  value={form[item.name]}
                  onChange={(value) => onChange(item, value)}
                  errorMessage={errors[item.name]}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={() => {
            defer.resolve(false);
            closePopup();
          }}
          className="popup-cancel-button"
        >
          {t('Cancel')}
        </button>
        <button type="submit" className="popup-confirm-button">
          {t('Submit')}
        </button>
      </div>
    </form>
  );
};

PayoutRequest.propTypes = {
  betId: PropTypes.object,
  closePopup: PropTypes.func,
  isCasino: PropTypes.bool,
};
export default PayoutRequest;
